import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Auth {
    isAuthenticate: boolean;
    isVerified: boolean;
    signInStep: string;
}

const initialState: Auth = {
    isAuthenticate: false,
    isVerified: false,
    signInStep: "LOGIN",
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loginSuccess: (state, action: PayloadAction<void>) => {
            state.isAuthenticate = true;
        },
        logout: (state, action: PayloadAction<void>) => {
            state.isAuthenticate = false;
            state.isVerified = false;
        },
        setSignInStep: (state, action: PayloadAction<string>) => {
            state.signInStep = action.payload;
        },
        verifiedOTP: (state, action: PayloadAction<void>) => {
            state.isVerified = true;
        },
    },
});

export const { loginSuccess, logout, setSignInStep, verifiedOTP } = authSlice.actions;
export default authSlice.reducer;
